// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1EllK","errorLogs":"EditorFooter_errorLogs__Z6z45"};